import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from 'seagull';
import { COBStep, getNextStepButtonText, getStepName, stepsTextsPath } from '~/client-flow/clientOb/ClientOnboarding.utils';
import { nextStepButtonTextsPath } from '~/client-flow/clientOb/ClientOnboardingInnerV2/ClientOnboardingV2.utils';
import { IntroVideo, IntroVideoTestIds } from '~/client-flow/clientOb/ClientOnboardingInnerV2/OnboardingPage/Steps/IntroVideoStep/IntroVideo';
import { useCobConfig } from '~/client-flow/clientOb/CobConfigContext';
import { StepPage } from '~/client-flow/components/StepPage';
import { useLocaleKeys } from '~/i18n';
export { IntroVideoTestIds as IntroVideoStepTestIds };
const IntroVideoStep = (param)=>{
    let { onDone, onBack } = param;
    const { relationship } = useCobConfig();
    const { t: stepsTexts } = useLocaleKeys(stepsTextsPath);
    const { t: clientFlowTexts } = useLocaleKeys(nextStepButtonTextsPath);
    return /*#__PURE__*/ _jsx(StepPage, {
        header: getStepName(COBStep.introVideo, relationship, stepsTexts),
        testId: IntroVideoTestIds.Root(),
        primaryBtn: /*#__PURE__*/ _jsx(Button, {
            onClick: onDone,
            children: getNextStepButtonText(COBStep.introVideo, relationship, clientFlowTexts)
        }),
        onBackBtnClick: onBack,
        children: /*#__PURE__*/ _jsx(IntroVideo, {})
    });
};
export default IntroVideoStep;
